import React, { Fragment } from "react";

import "./productcategorylist.scss";
import ProductCategory from "./ProductCategory";
import ClipLoader from "react-spinners/ClipLoader";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import "./productcategoryslider.scss";

SwiperCore.use([Pagination, Navigation]);
const ProductCategoryList = (props) => {
  return (
    <Fragment>
      <div className="product-category-list-container d-xl-flex mx-auto">
        {Object.entries(props.categories).length === 0 ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <ClipLoader color="#000" loading size={35} />
          </div>
        ) : props.categories.length < 8 ? (
          props.categories.map((category) => {
            return <ProductCategory key={category.id} category={category} />;
          })
        ) : (
          <Swiper
            spaceBetween={0}
            slidesPerView={8}
            pagination={{
              clickable: true,
            }}
            navigation={true}
          >
            {props.categories.map((category) => {
              return (
                <SwiperSlide key={category.id}>
                  <ProductCategory key={category.id} category={category} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>
    </Fragment>
  );
};

export default ProductCategoryList;
